export function featuredIconsAnimations() {
    let icons = $(".feature-links .icon");

    icons.each(function (i, item) {
        let src = item.getAttribute("data-json");
        if (src) {
            let temp = window.lottiejs.loadAnimation({
                container: item,
                path: src,
                autoplay: false,
                renderer: "svg"
            });

            $(item).parent("a").hover(function () {
                temp.setDirection(1);
                temp.play();
            }, function () {
                temp.setDirection(-1);
                temp.play();
            });
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/featuredIconsAnimations.js